import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["submitButton", "loadingButton"]

  close() {
    $(this.loadingButtonTarget).hide()
    $(this.submitButtonTarget).show()
    $(this.element).modal('hide')
  }

  // Handle successful form submission
  afterSubmit(event) {
    this.close()
  }
}
